/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import CommonModal from '../../../../../components/Modal';
import { useNavigate, useSearchParams } from "react-router-dom";

export default function InvoiceScheduledModal({ open, onClose, removeParams, studentCount, transactionId }) {
    const navigate = useNavigate();
    // const [invoiceScheduledModalOpen, setInvoiceScheduledModalOpen] = useState(false);

    const handleOnClick = () => {
        onClose();
        removeParams();
        navigate(`/student-master/invoice-list/bulk-invoice-history/invoice-issue-status?transaction_id=${transactionId}`)  
    };

    return (
        <CommonModal
            show={open}
            handleClose={onClose}
            title="Invoice issuing scheduled"
         
        >
            <div className="-mt-3 mb-4 w-[700px] " >
                <div className="text-center mb-4 mt-4">
                    Invoice issuing is scheduled for {studentCount} student{studentCount > 1 ? 's' : ''}.<br />
                    Check <span
                        onClick={() =>
                            navigate(`/student-master/invoice-list/bulk-invoice-history/invoice-issue-status?transaction_id=${transactionId}`)
                        }
                        className="text-[#106EB4] underline font-medium cursor-pointer"
                    >
                        Invoice Issue Status
                    </span> page for more details.
                </div>

                <div className="flex justify-center">
                    <button
                        className="actn-btn1"
                        onClick={handleOnClick}
                        type="button"
                    >
                        OK
                    </button>
                </div>
            </div>
        </CommonModal>
    );
} 